import { render, staticRenderFns } from "./MessageBoardCard.vue?vue&type=template&id=2a59a2e6&scoped=true&"
import script from "./MessageBoardCard.vue?vue&type=script&lang=js&"
export * from "./MessageBoardCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a59a2e6",
  null
  
)

export default component.exports